import React from "react";
import Image from "next/image";

interface PiggyTokenProps {
  isSmall?: boolean;
  customSize?: number;
}

export default function PiggyToken({ isSmall, customSize }: PiggyTokenProps) {
  return (
    <Image
      src="/assets/img/claim/piggy-token.svg"
      alt="$Piggy Token"
      width={customSize ? customSize : isSmall ? 20 : 65}
      height={customSize ? customSize : isSmall ? 20 : 65}
      priority
    />
  );
}
